import type { Client } from './_types';

/** @type {(client: client) => string} */
export const getClientInitials = (client) => {
  return client.clientName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};

/**
 * Converts client tags array to a comma-separated string
 * Matches v2's computed tagString property on the client model
 */
export const getTagString = (client: Client | null | undefined): string => {
  if (!client?.tags || !Array.isArray(client.tags)) return '';
  return client.tags.join(', ');
};
